import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import FromNow from 'components/Presentation/Dates/FromNow';
import { ColorLabel, ColorLabelContainer } from 'UI';
import { Icon, Flex, translate } from '@haldor/ui';
var DisplayAssignment = /*#__PURE__*/function (_Component) {
  function DisplayAssignment() {
    _classCallCheck(this, DisplayAssignment);
    return _callSuper(this, DisplayAssignment, arguments);
  }
  _inherits(DisplayAssignment, _Component);
  return _createClass(DisplayAssignment, [{
    key: "render",
    value: function render() {
      var _this = this;
      var translate = this.props.translate;
      var isHaldorAssignment = this.props.assignment.id == parseInt(this.props.assignment.id, 10);
      var addedColorDots = [];
      var color = '';
      if (this.props.color != null) {
        color = this.props.color;
      }
      var status = "";
      if (this.props.status != null) {
        var statusObject = this.props.status.assignmentTypes.find(function (type) {
          return type.id == _this.props.assignment.assignmentType;
        });
        if (statusObject != null) {
          status = statusObject.value;
        } else {
          if (this.props.assignment.externalId != null) {
            status = "Teams";
          }
        }
      }
      return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, isHaldorAssignment && this.props.assignment.courses != null && this.props.assignment.courses.length > 0 ? /*#__PURE__*/React.createElement(ColorLabelContainer, null, this.props.assignment.courses.map(function (course) {
        if (addedColorDots.find(function (t) {
          return t == course.id;
        }) == null) {
          var text = course.title;
          text = course.year != null ? text + ' ' + course.year : text;
          addedColorDots.push(course.id);
          return /*#__PURE__*/React.createElement(ColorLabel, {
            key: course.id,
            tooltip: text,
            color: course.colorCode
          });
        }
      })) : null, isHaldorAssignment ? /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.assignment.title) : /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.assignment.displayName), isHaldorAssignment ? /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 'var(--size-14)'
        }
      }, this.props.assignment.section != null ? this.props.assignment.section.title : '') : null), /*#__PURE__*/React.createElement("div", {
        className: "assignment-meta"
      }, /*#__PURE__*/React.createElement("div", null, isHaldorAssignment ? this.props.assignment.created != "0001-01-01T00:00:00" ? /*#__PURE__*/React.createElement(FromNow, null, this.props.assignment.dueDate) : null : /*#__PURE__*/React.createElement(FromNow, null, this.props.assignment.dueDateTime), this.props.assignment.assessmentId != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, this.props.translate('assessed')) : null, !isHaldorAssignment || this.props.assignment.externalID != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: 5
        }
      }, /*#__PURE__*/React.createElement("span", null, "Teams")) : this.props.assignment.created == "0001-01-01T00:00:00" ? /*#__PURE__*/React.createElement("span", {
        className: "badge-primary"
      }, this.props.translate("task-is-creating")) : /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, status), this.props.remove != null ? /*#__PURE__*/React.createElement("span", {
        className: "delete-resource",
        onClick: function onClick() {
          return _this.props.remove();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      })) : null), /*#__PURE__*/React.createElement("div", {
        className: "submission-info"
      }, this.props.assignment.assessmentId != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, "Bed\xF6md") : null)));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    status: state.base.status
  };
}
export default connect(mapStateToProps)(DisplayAssignment);